module.exports = __webpack_public_path__ + "img/unidad-4.9e4aac13.png";